(function () {
    'use strict';

    angular
        .module('loyalty')
        .config(LoyaltyRoute);

    LoyaltyRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function LoyaltyRoute($stateProvider) {
        $stateProvider
            .state('root.loyalty', {
                abstract: true,
                url: '/loyalty',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                }
            })
            .state ('root.loyalty.items', {
                url: '/serviceitems',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/loyalty/reports/serviceItems/list.html',
                        controller: 'LoyaltyProgramItemController',
                        controllerAs: 'loyaltyProgramItem'
                    }
                }
            })
            .state ('root.loyalty.redeemed', {
                url: '/servicesredeemed',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/loyalty/reports/redeemed/list.html',
                        controller: 'LoyaltyServiceRedeemedController',
                        controllerAs: 'loyaltyServiceRedeemed'
                    }
                }
            })
            .state ('root.loyalty.expiring', {
                url: '/expiring',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/loyalty/reports/expiring/list.html',
                        controller: 'LoyaltyExpiringController',
                        controllerAs: 'loyaltyExpiring'
                    }
                }
            });
    }
})();